import React, { useCallback } from "react";
import { Modal } from "@/components/Modal";
import { DotsLoader } from "@/components/common/Loader/DotsLoader";
import { Button } from "@/components/common/Button";
import { SpeakerIcon } from "@/components/common/icons/SpeakerIcon";
import { useBot } from "@/api/useBot";
import { useAudio } from "@/api/useAudio";
import { useWordTranslation } from "@/api/useWordTranslation";

import styles from "./WordModal.module.css";

type Props = {
  isOpen?: boolean;
  onClose: () => void;
  word?: string | null;
};

export const WordModal: React.FC<Props> = ({
  isOpen = false,
  onClose,
  word,
}) => {
  const { data: bot, isLoading } = useBot();
  const { playText } = useAudio();
  const {
    data: translation,
    isLoading: isTranslationLoading,
  } = useWordTranslation(word || undefined, bot?.language);

  const playWord = useCallback(() => {
    playText(word || "", bot!.voice);
  }, [playText, word, bot?.voice]);

  if (isTranslationLoading || isLoading) {
    return (
      <Modal withX className={styles.modal} isOpen={isOpen} onClose={onClose}>
        <DotsLoader />
      </Modal>
    );
  }

  if (!translation) {
    return (
      <Modal withX className={styles.modal} isOpen={isOpen} onClose={onClose}>
        <div className={styles.translationText}>Something went wrong</div>
      </Modal>
    );
  }

  return (
    <Modal withX className={styles.modal} isOpen={isOpen} onClose={onClose}>
      <div className={styles.emojiText}>{translation.emoji}</div>
      <Button variant="clean" onClick={playWord} className={styles.titleButton}>
        <div className={styles.wordTitle}>{translation.word}</div>
        <SpeakerIcon className={styles.speaker} />
      </Button>
      <div className={styles.translationText}>{translation.translation}</div>
    </Modal>
  );
};
